import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useLocation } from 'react-router-dom';
import { useGetCumulativeAssignmentReportWithRetakesMutation } from '../../../../../../features/authentication/reportApiSlice';

const StudentRetakeReport = () => {
  const location = useLocation();
  const { studentId, selectedClassId, retryCreditId } = location.state;
  const [getCumulativeAssignmentReportWithRetakes] = useGetCumulativeAssignmentReportWithRetakesMutation();

  var headerOptions = {
    reportTitle: 'Student Retake Report',
    showTeacherName: true,
    showStudentName: false,
    showClassName: false,
    showRetryInfo: true,
    showReportType: true,
    reportType: 'Assignment'
  };

  return (
    <QuestionBreakdownReport
      isRetakeReport={true}
      studentId={studentId}
      initialClassId={selectedClassId}
      reportTitle='Student Retake Report'
      exportFileName='StudentRetakeReport'
      reportDataEndpoint={getCumulativeAssignmentReportWithRetakes}
      goBackOnError={true}
      headerOptions={headerOptions}
      retryCreditId={retryCreditId}
    />
  );

};

export default StudentRetakeReport;